<template>
  <div class="col-12">
    <Search
      :allowFields="$lang.reportLang.ready_report_access_fields"
      :hiddenFields="hiddenFields"
      :allowCollapse="false"
      :url="url"
      :title="$lang.reportLang.ready_report_access_list"
      :isLoading="loading"
      addModalSize="xl"
      removeModalSize="xl"
      :visibleSearch="true"
      :visibleSettings="true"
      :visibleExport="true"
      :visibleFilters="true"
      :visibleViewCount="true"
      :allowEdit="false"
      :dynamicButtons="availableButtons"
      :filterCatch="true"
      :dataNotExist="$lang.notRecordExist"
      ref="readyReportAccess"
      @getPermisson="updatePermissions"
      :visibleAdd="isAdmin(parentPermissions, ['admin'])"
    >
      <template slot="addModal" slot-scope="search">
        <AddReadyReportAccessForm
          :parentPermissions="parentPermissions"
          @close="search.close"
          @getData="getData"
        />
      </template>
    </Search>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import AddReadyReportAccessForm from "../forms/addReadyReportAccessForm.vue";
import { isAdmin, generateApiUrl } from "@/shared/utils";

export default {
  components: {
    Search,
    AddReadyReportAccessForm,
  },
  data() {
    return {
      loading: false,
      availableButtons: [
        {
          id: "0",
          name: "delete",
        },
      ],
      hiddenFields: ["created_by", "created_at.jalali"],
      parentPermissions: [],
    };
  },
  computed: {
    url() {
      return generateApiUrl(["report", "ready_report_access"]);
    },
  },
  methods: {
    isAdmin,
    generateApiUrl,
    getData() {
      this.$refs.readyReportAccess.getItems();
    },
    updatePermissions(permissions) {
      this.parentPermissions = [...permissions];
    },
  },
};
</script>

